import { render, staticRenderFns } from "./AppHeaderV2ScoreSection.vue?vue&type=template&id=50b960c1&scoped=true"
import script from "./AppHeaderV2ScoreSection.vue?vue&type=script&lang=js"
export * from "./AppHeaderV2ScoreSection.vue?vue&type=script&lang=js"
import style0 from "./AppHeaderV2ScoreSection.vue?vue&type=style&index=0&id=50b960c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b960c1",
  null
  
)

export default component.exports